import React, { useEffect, useState } from "react";
import AbLogo from "../../../../assets/logo192.png";
import {
  getBase64ImageFromUrl,
  getImageUrls,
  getMinioImage,
} from "../../../../utils/helpers";
import Img from "../../../../components/Img";
import { get } from "react-hook-form";
import classNames from "classnames";
import ImgOptimized from "../../../../components/ImgOptimized";

const TopAbLogo = ({ companyLogo, isPdf, isVertical }) => {
  const [baseLogo, setBaseLogo] = useState(
    getImageUrls([companyLogo], true, true)?.[0],
  );
  async function getBaseLogo() {
    const logo = await getBase64ImageFromUrl(
      getImageUrls([companyLogo], true, true)?.[0],
    );
    setBaseLogo(logo);
  }
  useEffect(() => {
    isPdf && getBaseLogo();
  }, [companyLogo]);
  return (
    <div
      className={classNames(
        "flex items-center justify-start  max-w-fit ",
        isVertical ? "flex-col" : "gap-1.5",
      )}
    >
      <ImgOptimized
        src={AbLogo}
        alt="Company Logo"
        className={`${isPdf ? " w-10 h-10 " : " w-6 h-6 sm:w-6 sm:h-6 lg:w-6 lg:h-6 xl:w-[5.2vh] xl:h-[5vh]"}  object-cover rounded-lg`}
      />
      <span>x </span>
      {isPdf ? (
        <ImgOptimized
          src={baseLogo}
          alt="Company Logo"
          className="max-w-fit h-10   "
        />
      ) : (
        // <div className="border-green-400 border-2 flex justify-start">
        <ImgOptimized
          src={getImageUrls([companyLogo], true, true)?.[0]}
          alt="Company Logo"
          className="max-w-fit h-4 sm:h-6 lg:h-4  xl:h-[5vh]  "
        />
        // </div>
      )}
    </div>
  );
};

export default TopAbLogo;
